/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'sea',
    quality: 0.3,
    learning: 1,
	mana: 1,
	willpower: 1
}